/* eslint-disable no-param-reassign */
// eslint-disable-next-line import/no-extraneous-dependencies
import { produce } from 'immer';
import { promotionAccordions } from '../../../analytics';

export default (set, get, target) => set(produce(get(), (draft) => {
  if (!draft.digitalData) {
    draft.digitalData = { event: [] };
  }

  const trackPromotionAccordions = { target };

  draft.digitalData.promotionAccordions = trackPromotionAccordions;

  promotionAccordions(trackPromotionAccordions);
}), false, { type: 'TRACK_PROMOTION_ACCORDION_CLICK' });
